import FeatureFlagsService from 'garaje/services/feature-flags';

import type { TrafficType } from './splitio';

export default class LocationFeatureFlagsService extends FeatureFlagsService {
  trafficType: TrafficType = 'location';
}
